export default __webpack_public_path__ + "static/media/password.1e79fe22.svg";